/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { listReqTechs, unloadReqTechs } from '../../modules/techModule/techReqs';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';

import TechList from '../../components/techSupports/TechList';
import TechReqStatusList from '../../components/techSupports/TechReqStatusList';
import TechReqStatusChip from '../../components/common/datagrid/TechReqStatusChip';
import { TechReqListBox } from '../../components/techSupports/TechReqListBox';

const ReqTechListContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const [searchGrade, setSearchGrade] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("custNm");
  const [searchWords, setSearchWords] = useState(null);
  const [searchStrtDt, setSearchStrtDt] = useState('');
  const [searchEndDt, setSearchEndDt] = useState('')

  const { techs, error, loading } = useSelector(({ techModule, loading }) => ({
    techs: techModule.reqTechs.techs,
    error: techModule.reqTechs.error,
    loading: loading['tech/LIST_REQ_TECHS'],
  }));

  useEffect(() => {
    dispatch(listReqTechs());

    return () => {
      unloadReqTechs();
    }
  }, []);

  const searchList = (values) => {

    const startDate =
      values.searchStrtDt !== null && values.searchStrtDt !== ''
        ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      values.searchEndDt !== null && values.searchEndDt !== ''
        ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      reqGrade: searchGrade,
      [searchKeyword]: values.searchWords,
      strtDt: startDate,
      endDt: endDate,
    };

    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);
    setSearchStrtDt(values.searchStrtDt);
    setSearchEndDt(values.searchEndDt);

    dispatch(listReqTechs(searchData));

  }


  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,

      },
      {
        field: 'reqUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'reqStatus',
        headerName: '작업상태',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: TechReqStatusChip,
      },

      {
        field: 'custNm',
        headerName: '고객명',
        minWidth: 240,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'center',
      },
      {
        field: 'custEmpNm',
        headerName: '고객 담당자',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workTyp',
        headerName: '작업종류',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workStDt',
        headerName: '작업요청시작일',
        minWidth: 120,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workEdDt',
        headerName: '작업요청종료일',
        minWidth: 120,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'workEmpNm',
        headerName: '작업자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'left',

      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 180,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    navigate(`/reqtechmng/${param.id}`)
  };

  const initialValues = {
    searchKeyword: searchKeyword,
    searchWords: searchWords,
    searchStrtDt: searchStrtDt,
    searchEndDt: searchEndDt,
  };


  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '등록 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('등록 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  useEffect(() => {
    searchList(formik.values);
  }, [searchGrade])

  const onChangeGrade = (grade) => {

    if (grade === searchGrade) {
      grade = "";
    }

    setSearchGrade(grade);
  }

  return (
    <>
      <BreadcrumbsContainer title="기술지원/작업지원 요청 관리/요청 리스트" icon="tech" />
      <TechReqListBox formik={formik} />
      <TechReqStatusList searchGrade={searchGrade} onChangeGrade={onChangeGrade} />
      <TechList
        reqStatus
        columns={columns}
        rows={techs}
        loading={loading}
        handleRowClick={handleRowClick}
      />
    </>
  );
};

export default ReqTechListContainer;
